import script from "./post.vue?vue&type=script&setup=true&lang=js"
export * from "./post.vue?vue&type=script&setup=true&lang=js"

import "./post.vue?vue&type=style&index=0&id=124c6577&scoped=true&lang=scss"

import exportComponent from "/Users/windy/work/vue/zhibo_am/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-124c6577"]])

export default __exports__